import type { FC, ReactNode } from "react";

import { cn } from "@/lib/utils";

type Props = {
  title: string;
  description?: string;
  actions?: ReactNode;
  className?: string;
};

/** The 36px title-case header above each client profile section; no band fill. */
export const SectionHeader: FC<Props> = ({
  title,
  description,
  actions,
  className
}) => (
  <div
    data-slot="client-section-header"
    className={cn(
      "flex h-9 shrink-0 items-center justify-between gap-3 border-b border-line-1 px-4",
      className
    )}
  >
    <div className="flex min-w-0 items-baseline gap-2">
      <span className="text-base font-medium text-fg">{title}</span>
      {description ? (
        <span className="truncate text-sm text-fg-3">{description}</span>
      ) : null}
    </div>
    {actions ? (
      <div className="flex shrink-0 items-center gap-1.5">{actions}</div>
    ) : null}
  </div>
);
